import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { addMinutes, format } from 'date-fns'

import { useGET_groupCourseSessionsQuery } from 'redux/api/sessionsApi'

import Calendar from 'components/molecules/Calendar'

const SchoolSchedule: FC = () => {
  const { t } = useTranslation()

  const list = []

  const { data: sessions } = useGET_groupCourseSessionsQuery({
    page: 1
  })

  sessions?.results.forEach((session) => {
    list.push({
      groupId: 'session',
      title: `${session?.course_chapter}`,
      start: format(new Date(session.start_datetime), 'p'),
      end: session.duration_minutes
        ? format(addMinutes(new Date(session.start_datetime), session.duration_minutes), 'p')
        : null,
    })
  })

  return (
    <div style={{ margin: '40px' }}>
      <Calendar loadSessions={true} loadMilestones={true} loadMeetings={true} />
    </div>

  )
}

export default SchoolSchedule
